<template>
  <div>
    <div
      v-for="(resource, i) in getSortedResources"
      :key="i"
      class="mt-[30px] md:mt-[60px] w-[calc(100vw-24px)] lg:w-[calc(100vw-292px)] bg-[#F8F9F9]"
    >
      <h6 v-if="resource.sessionId" class="text-base font-aktiv-grotesk">
        Session {{ resource.sessionId }}:
      </h6>
      <h1 class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold">
        {{ resource.name }}
      </h1>
      <ResourcesSlider :category-index="i" :items="resource.resources" />
    </div>
    <!-- <div
      v-if="filteredBooks.length > 0"
      class="mt-[60px] w-[calc(100vw-24px)] mr-[24px] lg:ml-0 lg:w-full bg-[#F8F9F9]"
    >
      <h1
        class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold"
      >
        Book
      </h1>
      <div class="rounded-[16px] w-[228px] md:w-[262px] md:pr-6 lg:w-[287px]">
        <in-app-browser :href="bookUrl" target="_blank">
          <img
            class="w-full rounded-[16px] cursor-pointer"
            :src="filteredBooks[0].thumbnail"
          />
        </in-app-browser>
      </div>
    </div>
    <div
      v-if="filteredQuotes.length > 0"
      class="mt-[60px] w-[calc(100vw-24px)] lg:w-[calc(100vw-292px)] bg-[#F8F9F9]"
    >
      <h1
        class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold"
      >
        Quotes
      </h1>
      <ResourcesSlider :category-index="i" :items="filteredQuotes" />
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ResourcesSlider from '@/components/ResourcesPage/PlaybackResources/ResourcesSlider.vue';

export default {
  components: {
    ResourcesSlider,
  },
  props: {
    filteredResources: {
      type: Object,
    },
    filteredQuotes: {
      type: Array,
    },
    filteredBooks: {
      type: Array,
    },
  },
  computed: {
    ...mapState('filter', ['allResources', 'isLoading', 'scheduleMapping', 'schedule']),

    getSortedResources() {
      const results = [];
      for (const key in this.filteredResources) {
        const result = {
          sessionId: key,
          name: this.filteredResources[key].name,
          resources: this.filteredResources[key].resources,
        };
        results.push(result);
      }
      return results;
    },
    bookUrl() {
      if (this.filteredBooks) {
        return this.filteredBooks[0].resourceTranslations[0].resourceUrl;
      }
      return '';
    },
  },
};
</script>
